import React, { useCallback, useLayoutEffect, useRef, useState } from 'react';
import { IconButton } from '@atlaskit/button/new';
import Tooltip from '@atlaskit/tooltip';

import CopyIcon from '@atlaskit/icon/core/copy';
import CheckCircleIcon from '@atlaskit/icon/core/check-circle';

const TOOLTIP_CONTENT_REFRESH_INTERVAL = 2500;

const CopyButton = (props: { label: string; value: string } & React.RefAttributes<unknown>) => {
	const [linkCopied, setLinkCopied] = useState(false);

	const [message, setMessage] = useState(`Copy ${props.label}`);
	const updateTooltip = useRef<() => void>();

	useLayoutEffect(() => {
		updateTooltip.current?.();
	}, [message]);

	const copyLink = useCallback(async () => {
		if (typeof globalThis !== 'undefined' && globalThis.navigator?.clipboard) {
			try {
				await globalThis.navigator.clipboard.writeText(props.value);
				setLinkCopied(true);
				setMessage('Copied');
				setTimeout(() => {
					setLinkCopied(false);
					setMessage(`Copy ${props.label}`);
				}, TOOLTIP_CONTENT_REFRESH_INTERVAL);
			} catch (error) {
				// TODO: Handle error case where clipboard write fails
			}
		}
	}, [props.label, props.value]);

	return (
		<Tooltip
			content={({ update }) => {
				updateTooltip.current = update;
				return message;
			}}
			position="bottom"
		>
			<IconButton
				appearance="subtle"
				icon={linkCopied ? CheckCircleIcon : CopyIcon}
				label={`Copy ${props.label}`}
				isTooltipDisabled
				onClick={copyLink}
			/>
		</Tooltip>
	);
};

export default CopyButton;
